const SUPPORT_ARTICLES = {
  idv: "/articles/10119561-what-s-needed-to-successfully-complete-identity-verification",
  processingFee: "/articles/214284346",
  serviceFee: "/articles/10119442-what-is-the-peerspace-service-fee",
};

const addQueryParams = (url: string, queryParams?: string) => {
  if (!queryParams) {
    return url;
  }
  return `${url}?${queryParams}`;
};

/**
 * Map of pages that are routed to from web-2. Add any new page urls here rather than hardcoding them in components
 */
const allPageRoutes = {
  currentDetails: (bookingId: string, queryParams?: string) =>
    addQueryParams(`/inbox/${bookingId}/current-details`, queryParams),

  inbox: (bookingId?: string, queryParams?: string) =>
    addQueryParams(`/inbox${bookingId ? `/${bookingId}` : ""}`, queryParams),
  inquiry: (listingId: string) => `/inquiry/${listingId}`,
  listingPage: (
    listingId: string,
    queryParams?: string,
    urlPrefix?: string,
  ) => {
    const normalizedPrefix = urlPrefix?.replace(/^\/+|\/+$/g, "");
    return addQueryParams(
      `${normalizedPrefix ? `/${normalizedPrefix}` : ""}/pages/listings/${listingId}`,
      queryParams,
    );
  },
  listings: (listingId: string, queryParams?: string) =>
    addQueryParams(`/pages/listings/${listingId}`, queryParams),
  onboardingTurnaround: (queryParams?: string) =>
    addQueryParams(`/onboarding/turnaround`, queryParams),
  passwordReset: () => "/password-reset",
  payments: (bookingId: string, queryParams?: string) =>
    addQueryParams(`/inbox/${bookingId}/payment-details`, queryParams),
  signin: ({
    queryParams,
    urlPrefix,
  }: {
    queryParams?: string;
    urlPrefix?: string;
  }) =>
    addQueryParams(`${urlPrefix ? `/${urlPrefix}` : ""}/signin`, queryParams),
  signup: ({
    queryParams,
    urlPrefix,
  }: {
    queryParams?: string;
    urlPrefix?: string;
  }) =>
    addQueryParams(`${urlPrefix ? `/${urlPrefix}` : ""}/signup`, queryParams),
  support: (urlPrefix: string, article?: keyof typeof SUPPORT_ARTICLES) => {
    if (!article) {
      return `https://support.peerspace.com/${urlPrefix}`;
    }
    return `https://support.peerspace.com/${urlPrefix}${SUPPORT_ARTICLES[article]}`;
  },
  term: () => `/legal/terms`,
};

export { allPageRoutes };
